<template>
  <div>
    <Nav></Nav>
    <mdb-container class="page-title pt-4">
      <mdb-row class="mb-4">
        <mdb-col class="text-left">
          <h1>COMMUNITY</h1>
          <p>Select your topic of interest and join the conversation</p>
        </mdb-col>
      </mdb-row>
      <mdb-row class="community-cats mb-4">
        <mdb-col sm="6" xl="4">
          <router-link
            to="/community/community-list-discussions/How-to-find-clients"
            class="a-card tile-video"
          >
            <mdb-card class="top-bar-purple">
              <mdb-card-body>
                <mdb-card-title class="tile-title">How to find clients</mdb-card-title>
                <mdb-card-text>Join the conversation with regards to all things ‘finding clients’. Ask questions, give comments and share stories of both success and challenges.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted></mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col sm="6" xl="4">
          <router-link
            to="/community/community-list-discussions/How-to-sell-and-win"
            class="a-card tile-video"
          >
            <mdb-card class="top-bar-blue">
              <mdb-card-body>
                <mdb-card-title class="tile-title">How to sell & win</mdb-card-title>
                <mdb-card-text>Ask questions, give comments and share stories of both success and challenges with regards to all things selling and winning.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted></mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col sm="6" xl="4">
          <router-link
            to="/community/community-list-discussions/How-to-sell-more"
            class="a-card tile-video"
          >
            <mdb-card class="top-bar-violet">
              <mdb-card-body>
                <mdb-card-title class="tile-title">How to sell more</mdb-card-title>
                <mdb-card-text>Collaborate with others, by asking questions, giving comments and sharing stories with regards to all things keeping clients and getting them to buy more.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                <span></span>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col sm="6" xl="4">
          <router-link
            to="/community/community-list-discussions/Tell-us-what-you-like"
            class="a-card tile-video"
          >
            <mdb-card class="top-bar-yellow">
              <mdb-card-body>
                <mdb-card-title class="tile-title">Tell us what you like</mdb-card-title>
                <mdb-card-text>Exsellance community is run by members like you, so be active and have your say in upcoming sales topics, share your sales challenges and sales success stories. Over time, we will reward those who contribute more.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted></mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col sm="6" xl="4">
          <router-link
            to="/community/community-list-discussions/10-critical-sales-skills"
            class="a-card tile-video"
          >
            <mdb-card class="top-bar-purple">
              <mdb-card-body>
                <mdb-card-title class="tile-title">10 Critical Sales Skills</mdb-card-title>
                <mdb-card-text>Learn together by sharing your favourite resources, ideas, challenges and stories.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted></mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col sm="6" xl="4">
          <router-link
            to="/community/community-list-discussions/Technical-help-and-Support"
            class="a-card tile-video"
          >
            <mdb-card class="top-bar-green">
              <mdb-card-body>
                <mdb-card-title class="tile-title">Technical help and Support</mdb-card-title>
                <mdb-card-text>Post your question/technical issue and we will get back to you quickly</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted></mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <!--
      <mdb-row class="community-cats mb-4">
        <mdb-col sm="6" xl="4" >
          <router-link to="/community/community-list-discussions/general" class="a-card tile-video">
            <mdb-card class="top-bar-purple">
              <mdb-card-body>
                <mdb-card-title class="tile-title">General</mdb-card-title>
                <mdb-card-text>Revaluation virtues enlightenment passion.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>Tips to make your life easier | 2 hours ago</mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col sm="6" xl="4">
          <router-link to="/community-list-discussions/tips-and-tricks" class="a-card tile-video">
            <mdb-card class="top-bar-blue">
              <mdb-card-body>
                <mdb-card-title class="tile-title">Tips and tricks</mdb-card-title>
                <mdb-card-text>Justice contradict battle enlightenment christian ubermensch ascetic society.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>Tips to make your life easier | 2 hours ago</mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col sm="6" xl="4">
          <router-link to="/community-list-discussions/why-selling-is-important" class="a-card tile-video">
            <mdb-card class="top-bar-violet">
              <mdb-card-body>
                <mdb-card-title class="tile-title">Why selling is important</mdb-card-title>
                <mdb-card-text>Insofar horror inexpedient .</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>
                3 masterclasses
                <span>Tips to make your life easier | 2 hours ago</span>
              </mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col sm="6" xl="4">
          <router-link to="/community-list-discussions/finding-clients" class="a-card tile-video">
            <mdb-card class="top-bar-green">
              <mdb-card-body>
                <mdb-card-title class="tile-title">Finding clients</mdb-card-title>
                <mdb-card-text>Insofar horror inexpedient moral christian.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>Tips to make your life easier | 2 hours ago</mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col sm="6" xl="4">
          <router-link to="/community-list-discussions/selling-more" class="a-card tile-video">
            <mdb-card class="top-bar-yellow">
              <mdb-card-body>
                <mdb-card-title class="tile-title">Selling more</mdb-card-title>
                <mdb-card-text>Justice contradict battle enlightenment.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>Tips to make your life easier | 2 hours ago</mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
        <mdb-col sm="6" xl="4">
          <router-link to="/community-list-discussions/building-a-sales-team" class="a-card tile-video">
            <mdb-card class="top-bar-purple">
              <mdb-card-body>
                <mdb-card-title class="tile-title">Building a sales team</mdb-card-title>
                <mdb-card-text>Snare joy philosophy ascetic passion pious.</mdb-card-text>
              </mdb-card-body>
              <mdb-card-footer small muted>Tips to make your life easier | 2 hours ago</mdb-card-footer>
            </mdb-card>
          </router-link>
        </mdb-col>
    </mdb-row>-->

    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge
} from "mdbvue";

export default {
  name: "Community",
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge
  }
};
</script>

<style>
@import url("https://use.typekit.net/lel8wuy.css");
</style>
